import PropTypes from 'prop-types';

import type { IconType } from '../../../../theme/themes/ThemeTypes';

const Today: IconType = ({ colour, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={46} height={42} {...props}>
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      fill="#FFF"
      d="M36.752 13.33V4.336a.911.911 0 0 0-.913-.912h-3.662a.911.911 0 0 0-.913.912v3.918l-7.642-7.009a.905.905 0 0 0-1.24 0L2.205 20.168a.908.908 0 0 0 .62 1.582h4.588v17.413c0 1.01.816 1.837 1.838 1.837h27.5c1.01 0 1.837-.815 1.837-1.837V21.75h4.588a.911.911 0 0 0 .912-.913.969.969 0 0 0-.292-.681l-7.033-6.839-.012.012Z"
    />
  </svg>
);

Today.propTypes = {
  colour: PropTypes.string.isRequired,
};

export default Today;
